<template lang="pug">
b-modal#editMiniGameRewardOp(
  ref="editMiniGameRewardOp"
  :title="$t('ui.combine.edit_reward')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
  )
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    template(v-if="item != null")
      b-form-group(:label="$t('ui.reward_code')" disabled).mb-1
        DebounceInput(
          size="sm"
          ref="reward_code"
          required
          type="text"
          :dirty="$v.reward_code.$dirty"
          :error="$v.reward_code.$error"
          v-model.trim.lazy="$v.reward_code.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.reward_code" :name="$t('ui.reward_code')")
      b-form-group(:label="$t('ui.reward_name')").mb-1
        DebounceInput(
          size="sm"
          ref="reward_name"
          required
          type="text"
          :dirty="$v.reward_name.$dirty"
          :error="$v.reward_name.$error"
          v-model.trim.lazy="$v.reward_name.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.reward_name" :name="$t('ui.reward_name')")
      b-form-group(:label="$t('ui.reward_description')").mb-1
        DebounceInput(
          size="sm"
          ref="reward_description"
          required
          type="text"
          :dirty="$v.reward_description.$dirty"
          :error="$v.reward_description.$error"
          v-model.trim.lazy="$v.reward_description.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.reward_description" :name="$t('ui.reward_description')")
      b-form-group(:label="$t('ui.reward_probability')").mb-1
        DebounceInput(
          size="sm"
          ref="reward_probability"
          required
          type="number"
          :dirty="$v.reward_probability.$dirty"
          :error="$v.reward_probability.$error"
          v-model.trim.lazy="$v.reward_probability.$model"
          :disabled="loading"
          keyPressRestrict="restrictTwoDPlace"
        )
        ValidateResult(:value="$v.reward_probability" :name="$t('ui.reward_probability')" :fvalue="'0'")
      b-form-group(:label="$t('ui.reward')").mb-1
        template(v-if="item.game_type.toLowerCase() != 'scratch'")
          DebounceInput(
            size="sm"
            ref="reward"
            required
            type="number"
            :dirty="$v.reward.$dirty"
            :error="$v.reward.$error"
            v-model.trim.lazy="$v.reward.$model"
            :disabled="loading"
            keyPressRestrict="restrictTwoDPlace"
          )
          ValidateResult(:value="$v.reward" :name="$t('ui.reward')" :fvalue="'0'")
        template(v-else)
          .row
            .col-6
              b-form-group(:label="$t('ui.from')").mb-1
                DebounceInput(
                  size="sm"
                  ref="reward_from"
                  required
                  type="number"
                  :dirty="$v.reward_from.$dirty"
                  :error="$v.reward_from.$error"
                  v-model.trim.lazy="$v.reward_from.$model"
                  :disabled="loading"
                  keyPressRestrict="restrictTwoDPlace"
                )
                ValidateResult(:value="$v.reward_from" :name="$t('ui.from')" :name2="$t('ui.to')" :fvalue="'0'")
            .col-6
              b-form-group(:label="$t('ui.to')").mb-1
                DebounceInput(
                  size="sm"
                  ref="reward_to"
                  required
                  type="number"
                  :dirty="$v.reward_to.$dirty"
                  :error="$v.reward_to.$error"
                  v-model.trim.lazy="$v.reward_to.$model"
                  :disabled="loading"
                  keyPressRestrict="restrictTwoDPlace"
                )
                ValidateResult(:value="$v.reward_to" :name="$t('ui.to')" :name2="$t('ui.from')" :fvalue="'0'")

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.close')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, maxValue } from "vuelidate/lib/validators";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import config from "@/config";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      reward_code: '',
      reward_name: '',
      reward_description: '',
      reward_probability: 0,
      reward_from: 0,
      reward_to: 0,
      reward: 0
    };
  },
  validations: {
    reward_code: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },
    reward_name: {
      minLength: minLength(2),
      maxLength: maxLength(50)
    },
    reward_description: {
      minLength: minLength(2),
      maxLength: maxLength(100)
    },
    reward_probability: {
      required,
      mustMoreThanOrEqual: function(value) {
        if(parseFloat(value) < 0) return false
        return true
      },
      maxValue: maxValue(100)
    },
    reward: {
      required,
      mustMoreThanOrEqual: function(value) {
        if(this.item.game_type.toLowerCase() == 'scratch') return true
        if(parseFloat(value) < 0) return false
        return true
      }
    },
    reward_from: {
      required,
      moreThan: function(value) {
        if(parseFloat(value) > parseFloat(this.reward_to)) return false
        return true
      },
      mustMoreThanOrEqual: function(value) {
        if(this.item.game_type.toLowerCase() != 'scratch') return true
        if(parseFloat(value) < 0) return false
        return true
      }
    },
    reward_to: {
      required,
      lessThan: function(value) {
        if(parseFloat(this.reward_from) > parseFloat(value)) return false
        return true
      },
      mustMoreThanOrEqual: function(value) {
        if(this.item.game_type.toLowerCase() != 'scratch') return true
        if(parseFloat(value) < 0) return false
        return true
      }
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editOperatorMiniGameRewardUrl();

        var json = {
          auth_token: this.$store.getters.sessionToken,
          action_by: this.$store.getters.loginId,
          operator_game_id: this.item.operator_game_id,
          reward_code: this.item.reward_code,
          reward_name: this.reward_name,
          reward_description: this.reward_description,
          reward_probability: this.reward_probability
        };
        if(this.item.game_type.toLowerCase() != 'scratch') {
          json.reward = parseFloat(this.reward).toFixed(2)
        } else {
          json.reward = parseFloat(this.reward_from).toFixed(2) + '-' + parseFloat(this.reward_to).toFixed(2)
        }

        this.feedback.success = true;
        this.loading = true;

        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "combine.edit_reward", this.feedback.status);
                }
                this.$nextTick(() => {
                  this.$refs.editMiniGameRewardOp.hide();
                });
              }
            } catch (error) {
              this.loading = false;
              if (error.status.toLowerCase() == "nochanges") {
                this.$emit("clicked");
                this.$nextTick(() => {
                  this.$refs.editMiniGameRewardOp.hide();
                });
              } else {
                this.feedback.success = false;
                this.feedback.status = error.status;
                this.$helpers.handleFeedback(this.feedback.status);
              }
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.handleFeedback(this.feedback.status);
          }
        );
      }
    },
    reset() {
      this.reward_code = ''
      this.reward_name = ''
      this.reward_description = ''
      this.reward_probability = 0
      this.reward = 0
      this.reward_from = 0
      this.reward_to = 0
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.$v.$reset();
      this.$refs.reward_name.$el.focus();
      this.reward_code = this.item.reward_code
      this.reward_name = this.item.reward_name
      this.reward_description = this.item.reward_description
      this.reward_probability = parseFloat(this.item.reward_probability).toFixed(2)
      if(this.item.game_type.toLowerCase() != 'scratch') {
        this.reward = this.item.reward
      } else {
        var val = this.item.reward.split('-')
        this.reward_from = val[0]
        this.reward_to = val[1]
      }
    }
  }
};
</script>
